/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const FileStack = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22 10V23H4V21.5H20.5V10H22ZM13 1L19 8.25V20H2V1H13ZM12.294 2.5H3.5V18.5H17.5V8.79L12.294 2.5ZM12 4V8.999L16 9V10.5H10.5V4H12Z"
                        fill={color}
                    />
                </svg>
        );
    };
